import { Shift, ShiftAutoFill, ShiftCreate, ShiftDetail } from '../bus/shift/types';
import $axios from '../utils/axios-instance';

export default class ShiftApi {
  async getShiftList() {
    return await $axios
      .get<{ data: any }>('/v1/Shift')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getShiftDetail(data: { shiftId: number; requstId: number }) {
    return await $axios
      .get<{ data: any }>(`/v1/Shift/${data.shiftId}/${data.requstId}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getShiftCurrent() {
    return await $axios
      .get<Shift>('/v1/Shift/current')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async shiftOpen() {
    return await $axios
      .post('/v1/Shift/open')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async shiftClose() {
    return await $axios
      .post('/v1/Shift/close')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async shiftCreate(data: ShiftCreate) {
    return await $axios
      .post(`/v1/Shift/${data.employeeId}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async shiftDetail(data: ShiftDetail) {
    return await $axios
      .get(`/v1/Shift/${data.employeeId}/details?date=${data.date}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async autoFill(data: ShiftAutoFill) {
    return await $axios
      .post('/v1/Shift/autoFill', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
